var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:_vm.className,on:{"click":function($event){return _vm.$emit('action')}}},[_c('font-awesome-icon',{style:(_vm.styles),attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }